module.exports = __webpack_public_path__ + "img/logo.91ad8972.webp";